export default "images/main.png"